import React from 'react'
import FaqSection from '../FaqSection/FaqSection'

function FaqPage() {
    return (
        <div className='FaqPage_main'>
            <FaqSection />
        </div>
    )
}

export default FaqPage